import React from "react";
import { useSelector } from "react-redux";

const Stats = () => {
  const { stats } = useSelector((state) => state.home);
  const color = ["var(--green)", "var(--primary)", "var(--green)", "#FE7A95"];

  return (
    <div className="statsContainer">
      {stats.map((item, index) => {
        return (
          <div
            key={index}
            className="statsCard"
            style={{ borderColor: color[index] }}
          >
            <p>{item.title}</p>
            <h2>{item.value}%</h2>
          </div>
        );
      })}
    </div>
  );
};

export default Stats;
